import request from '@/utils/request'
// 创建供应商账户
export function createSupplierAccount(data) {
  return request({
    url: `/supplier_accounts`,
    method: 'post',
    data
  })
}
